<template>
  <div class="service-apply">
    <div class="bread-crumbs">
      <div class="crumbs-item" @click="onOrderList">订单列表</div>
      <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
      <div class="crumbs-item" @click="onOrderDetail">订单详情</div>
      <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
      <div class="crumbs-item active">申请售后</div>
    </div>
    <template v-if="!curr_step">
      <div class="apply-body">
        <div class="product-box">
          <img
            :src="goods.product_image | default_img"
            alt=""
            class="product-img"
          />
          <div class="product-info">
            <div class="product-name">{{ goods.product_name }}</div>
            <div class="product-spec">{{ goods.spec_info }}</div>
          </div>
        </div>
        <div class="service-title">选择服务类型</div>
        <div class="service-list">
          <div class="service-item" @click="onApplyTypeChange(3)">
            <img
              src="@/assets/images/shop/icon-refund.png"
              alt=""
              class="service-icon"
            />
            <div class="service-text-box">
              <div class="title-text">我要退款(无需退货)</div>
              <div class="title-desc">
                没收到货,或与卖家协商同意不用退货只退款
              </div>
            </div>
          </div>
          <div class="service-item" @click="onApplyTypeChange(1)">
            <img
              src="@/assets/images/shop/icon-back-all.png"
              alt=""
              class="service-icon"
            />
            <div class="service-text-box">
              <div class="title-text">我要退货退款</div>
              <div class="title-desc">已收到货,需要退还收到的货物</div>
            </div>
          </div>
          <div class="service-item" @click="onApplyTypeChange(2)">
            <img
              src="@/assets/images/shop/icon-exchange.png"
              alt=""
              class="service-icon"
            />
            <div class="service-text-box">
              <div class="title-text">我要换货</div>
              <div class="title-desc">已收到货,需要退还更换</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="curr_step > 0">
      <div class="apply-body-with-form">
        <div class="top-status-box">
          <div class="step-info">
            <div class="step-item" v-for="(item, index) in steps" :key="index">
              <div
                :class="['line', { active: index <= apply_step }]"
                v-if="index != 0"
              ></div>
              <div class="dot-info-box">
                <div :class="['dot', { active: index < apply_step }]"></div>
                <div class="title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-detail-body">
          <div class="left-form">
            <!-- <template v-if=""></template> -->
            <div class="form-item">
              <div class="item-label">原商品:</div>
              <div class="item-value product-info">
                <img
                  :src="goods.product_image | default_img"
                  alt=""
                  class="product-img"
                />
                <div class="product-info">
                  <div class="product-name">{{ goods.product_name }}</div>
                  <div class="product-spec">{{ goods.spec_info }}</div>
                  <div class="product-price">
                    ¥{{ goods.price | price_format }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-item" v-if="form.type != '3'">
              <div class="item-label required">服务类型:</div>
              <div class="item-value radio-box">
                <RadioGroup v-model="form.type">
                  <Radio :label="1" :disabled="!!service_uuid">退货退款</Radio>
                  <Radio :label="2" :disabled="!!service_uuid">换货</Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="form-item">
              <div class="item-label required">
                {{
                  form.type == 3
                    ? "退款原因"
                    : form.type == 2
                    ? "换货原因"
                    : "退货原因"
                }}:
              </div>
              <div class="item-value">
                <Select
                  v-model="form.reason"
                  :placeholder="`请选择${
                    form.type == 3
                      ? '退款原因'
                      : form.type == 2
                      ? '换货原因'
                      : '退货原因'
                  }`"
                >
                  <Option label="不想要了" value="不想要了">不想要了</Option>
                  <Option label="7天无理由" value="7天无理由">7天无理由</Option>
                  <Option label="产品缺货" value="产品缺货">产品缺货</Option>
                  <Option label="质量问题" value="质量问题">质量问题</Option>
                </Select>
              </div>
            </div>
            <div class="form-item" v-if="form.type == 2">
              <div class="item-label required">换新商品:</div>
              <template v-if="!form.spec_color_uuid && !form.spec_size_uuid">
                <div
                  class="item-value product-select"
                  @click="show_exchange_goods = true"
                >
                  请选择换新商品规格
                  <Icon type="ios-arrow-forward" size="16" color="#0d99ff" />
                </div>
              </template>
              <template v-else>
                <div class="item-value product-info">
                  <img
                    :src="goods.product_image | default_img"
                    alt=""
                    class="product-img"
                  />
                  <div class="product-info">
                    <div class="product-name">
                      {{ goods.product_name }}
                      <span @click="show_exchange_goods = true">重选</span>
                    </div>
                    <div class="product-spec">{{ new_spec }}</div>
                    <div class="product-price">
                      ¥{{ goods.price | price_format }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div
              class="form-item label-align-start"
              v-if="[1, 3].includes(Number(form.type))"
            >
              <div class="item-label">退款金额:</div>
              <div class="item-value">
                <Input
                  v-model="form.money"
                  type="number"
                  placeholder="请输入退款金额"
                  @on-blur="onPriceBlur"
                />
                <div class="money-tip">
                  最多 ¥{{
                    goods.money | price_format
                  }},含发货邮费¥0.00,其中包含部分积分
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="item-label">
                {{
                  form.type == 3
                    ? "退款说明"
                    : form.type == 2
                    ? "换货说明"
                    : "退货说明"
                }}:
              </div>
              <div class="item-value">
                <Input
                  v-model="form.user_memo"
                  type="textarea"
                  :placeholder="`请输入${
                    form.type == 3 ? '退款' : form.type == 2 ? '换货' : '退货'
                  }说明`"
                  :autosize="{ minRows: 4 }"
                />
              </div>
            </div>
            <div class="form-item label-align-start">
              <div class="item-label">上传凭证:</div>
              <div class="item-value img-list">
                <template v-for="(item, index) in form.user_proof">
                  <!-- 图片凭证 -->
                  <div
                    class="img-item"
                    v-if="util.test_image(item)"
                    v-viewer
                    :key="`img-${index}`"
                  >
                    <img :src="item | default_img" alt="" />
                    <Icon
                      @click.stop="onProofDel(index)"
                      type="ios-close-circle"
                      class="close-ico"
                      size="20"
                    />
                  </div>
                  <!-- 视频凭证 -->
                  <div
                    class="img-item video-item"
                    v-else-if="util.is_video(item)"
                    :key="`video-${index}`"
                    @click="previewVideo(item)"
                  >
                    <video :src="item" class="video-thumb"></video>
                    <div class="video-play-icon">
                      <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                    <Icon
                      @click.stop="onProofDel(index)"
                      type="ios-close-circle"
                      class="close-ico"
                      size="20"
                    />
                  </div>
                </template>
                <Upload
                  v-if="form.user_proof.length < 10"
                  action="/"
                  :before-upload="onBeforeUpload"
                  multiple
                  :accept="'image/*,video/*'"
                >
                  <div class="upload-btn">
                    <img
                      src="@/assets/images/icon-upload.png"
                      alt=""
                      class="upload-ico"
                    />
                    <div class="upload-main-text">上传图片/视频</div>
                    <div class="upload-sub-text">(最多10个)</div>
                  </div>
                </Upload>
              </div>
            </div>
            <div class="submit-btn" @click="onApplySubmit">提交申请</div>
          </div>
          <div class="right-form">
            <div class="detail-title">订单详情</div>
            <div class="detail-product-box">
              <img
                :src="goods.product_image | default_img"
                alt=""
                class="detail-product-img"
              />
              <div class="detail-product-info">
                <div class="product-title">{{ goods.product_name }}</div>
                <div class="product-spec">{{ goods.spec_info }}</div>
              </div>
            </div>
            <div class="detail-list-box">
              <div class="detail-list-item">
                <div class="list-item-label">卖家:</div>
                <div class="list-item-value shop-name">
                  {{ detail.shop_name }}
                  <img
                    v-if="userInfo.id != detail.shop.user_id"
                    @click="onChatClick(detail.shop.designer_info)"
                    src="@/assets/images/icon-mall-cart-service.png"
                  />
                </div>
              </div>
              <div class="detail-list-item">
                <div class="list-item-label">订单编号:</div>
                <div class="list-item-value">{{ detail.order_no }}</div>
              </div>
              <div class="detail-list-item">
                <div class="list-item-label">单价:</div>
                <div class="list-item-value">
                  ¥{{ goods.price | price_format }}*{{ goods.quantity }}(数量)
                </div>
              </div>
              <div class="detail-list-item">
                <div class="list-item-label">邮费:</div>
                <div class="list-item-value">¥{{ 0 | price_format }}</div>
              </div>
              <div class="detail-list-item">
                <div class="list-item-label">商品总价:</div>
                <div class="list-item-value">
                  ¥{{ detail.total_price | price_format }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <exchange-goods
      v-if="show_exchange_goods"
      :goods="goods"
      @close="show_exchange_goods = false"
      @confirm="onExchangeGoodsConfirm"
    />
    <!-- 视频预览弹窗 -->
    <div v-if="videoPreviewVisible" class="video-preview-mask" @click="closeVideoPreview">
      <div class="video-preview-container" @click.stop>
        <div class="video-preview-close" @click="closeVideoPreview">×</div>
        <video :src="currentVideoUrl" controls autoplay class="video-preview"></video>
      </div>
    </div>
    <chat ref="chat"></chat>
  </div>
</template>
<script>
import {
  AfterSaleApply,
  AfterSaleDetail,
  MallOrderDetail,
  ModifyServiceApply,
} from "@/api/index";
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
import { mapState } from "vuex";
import ExchangeGoods from "../components/ExchangeGoods.vue";
export default {
  components: {
    ExchangeGoods,
  },
  data() {
    return {
      curr_step: 0,
      order_id: "",
      goods_id: "",
      og_uuid: "",
      form: {
        type: "", // 1退货退款 2换货 3仅退款
        user_proof: [], // 用户上传的凭证图片/视频
      },
      apply_step: 1,
      show_exchange_goods: false,
      detail: {},
      new_spec: "",
      exchange_num: "",
      service_uuid: "",
      videoPreviewVisible: false,
      currentVideoUrl: "",
      util,
      uploadQueue: [],
      debounceTimer: null,
      debounceTime: 300,
    };
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      userInfo: (state) => state.userInfo,
    }),
    steps() {
      const { form } = this;
      const { type } = form;
      let data = [];
      switch (Number(type)) {
        default:
          data = [
            {
              title: "买家申请退款",
            },
            {
              title: "卖家处理退款申请",
            },
            {
              title: "退款完毕",
            },
          ];
          break;
        case 1:
          data = [
            {
              title: "买家申请退货退款",
            },
            {
              title: "卖家处理退货退款申请",
            },
            {
              title: "买家退货",
            },
            {
              title: "卖家确认收货",
            },
            {
              title: "退货退款完毕",
            },
          ];
          break;
        case 2:
          data = [
            {
              title: "买家申请换货",
            },
            {
              title: "卖家处理换货申请",
            },
            {
              title: "买家退货",
            },
            {
              title: "卖家换新",
            },
            {
              title: "换货完成",
            },
          ];
          break;
      }
      console.log("data", data);
      return data;
    },
    goods() {
      const { detail } = this;
      const { goods } = detail;
      console.log("goods--->", goods);
      if (!goods) return {};
      return goods.find((item) => item.uuid == this.og_uuid) || {};
    },
  },
  watch: {},
  mounted() {
    const { order_id, goods_id, service_uuid, og_uuid } = this.$route.query;
    if (!order_id || !goods_id) return;
    this.order_id = order_id;
    this.goods_id = goods_id;
    this.og_uuid = og_uuid;
    this.$nextTick(() => {
      console.log("aaa-scroll");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
    if (service_uuid) {
      this.service_uuid = service_uuid;
      this.onGetServiceDetail();
    }
    this.onGetOrderDetail();
  },
  methods: {
    onChatClick(user) {
      this.$refs["chat"].showChat(user);
    },
    onPriceBlur() {
      const { form, goods } = this;
      const { money: form_money } = form;
      const { money } = goods;
      if (form_money > money) {
        this.form.money = money;
        this.$layer.msg(`最多可退款金额为:${this.form.money}`);
      }
    },
    async onGetServiceDetail() {
      try {
        const { code, msg, data } = await AfterSaleDetail({
          uuid: this.service_uuid,
        });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        if (data.newspec) {
          this.form = {
            ...this.form,
            type: data.type,
            reason: data.user_reason,
            user_proof: data.user_proof,
            user_memo: data.user_memo,
            spec_color_uuid: data.newspec.attr2_uuid,
            spec_size_uuid: data.newspec.attr1_uuid,
            money: data.apply_money,
            new_spec_quantity: data.new_spec_quantity,
            new_spec_id: data.new_spec_id,
          };
          this.new_spec = data.newspec.spec_info;
          console.log("form====>", this.form);
        } else {
          this.form = {
            ...this.form,
            type: data.type,
            reason: data.user_reason,
            user_proof: data.user_proof,
            user_memo: data.user_memo,
            money: data.apply_money,
          };
          console.log("form====>", this.form);
        }

        this.curr_step = 1;
      } catch (e) {
        console.log("err-service-detail", e);
        this.$layer.msg(e.msg);
      }
    },
    onExchangeGoodsConfirm(data) {
      console.log("data", data);
      this.new_spec = data.color_name + " " + data.size_name;
      this.form.spec_color_uuid = data.spec_color_uuid;
      this.form.spec_size_uuid = data.spec_size_uuid;
      this.form.new_spec_quantity = data.new_spec_quantity;
      this.exchange_num = data.new_spec_quantity;
      this.show_exchange_goods = false;
    },
    async onApplySubmit() {
      try {
        const { form } = this;
        if (!form.type) {
          this.$layer.msg("请选择退货服务类型");
          return;
        }
        const reasonLabel = form.type == 3 ? "退款原因" : form.type == 2 ? "换货原因" : "退货原因";
        if (!form.reason) {
          this.$layer.msg(`请选择${reasonLabel}`);
          return;
        }
        if (form.type == 2) {
          if (!form.spec_color_uuid || !form.spec_size_uuid) {
            this.$layer.msg("请选择要更换的新规格");
            return;
          }
        }
        console.log("form", {
          ...form,
          order_uuid: this.order_id,
          goods_uuid: this.goods.uuid,
        });
        let response;

        if (this.service_uuid) {
          Reflect.deleteProperty(form, "order_uuid");
          Reflect.deleteProperty(form, "goods_uuid");
          Reflect.deleteProperty(form, "type");
          response = await ModifyServiceApply({
            ...form,
            service_uuid: this.service_uuid,
          });
        } else {
          response = await AfterSaleApply({
            ...form,
            order_uuid: this.order_id,
            goods_uuid: this.goods.uuid,
          });
        }

        const { code, msg, data } = response;
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg("申请成功~,请耐心等待卖家处理~");
        this.$router.push({
          name: "ServiceDetail",
          query: {
            order_id: this.order_id,
            goods_id: this.goods.uuid,
            service_uuid: data.uuid,
          },
        });
      } catch (e) {
        console.log("err-apply-submit", e);
        this.$layer.msg(e.msg);
      }
    },
    async onGetOrderDetail() {
      try {
        const { code, msg, data } = await MallOrderDetail({
          uuid: this.order_id,
        });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.detail = data;
        console.log("data-order-detail", data);
      } catch (e) {
        console.log("err-order-detail", e);
        this.$layer.msg(e.msg);
      }
    },
    onProofDel(index) {
      this.form.user_proof.splice(index, 1);
    },
    previewVideo(url) {
      this.currentVideoUrl = url;
      this.videoPreviewVisible = true;
    },
    closeVideoPreview() {
      this.videoPreviewVisible = false;
      this.currentVideoUrl = "";
    },
    onApplyTypeChange(val) {
      console.log("val", val);
      this.curr_step = 1;
      this.form.type = val;
    },
    onBeforeUpload(file) {
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
        this.processAllFiles();
      }, this.debounceTime);

      return false;
    },
    async processAllFiles() {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`开始上传 ${queue.length} 个文件`);

      for (const file of queue) {
        try {
          if (this.form.user_proof.length >= 10) {
            this.$layer.msg("最多只能上传10个文件");
            break;
          }
          const url = await uploadFileToOSS(file, "template");
          this.form.user_proof.push(url);
        } catch (err) {
          console.log("err-upload", err);
          this.$layer.msg(`上传失败：${file.name}`);
        }
      }
    },
    onOrderList() {
      this.$router.push({
        name: "MallOrderCenter",
      });
    },
    onOrderDetail() {
      this.$router.push({
        name: "OrderDetail",
        query: {
          uuid: this.order_id,
          from: "mall",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.service-apply {
  width: 100%;
  height: 100%;
  background: #f8f9fb;
  padding: 0 94px 120px 30px;
  user-select: none;
  .bread-crumbs {
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding-bottom: 22px;
    padding-top: 20px;
    .crumbs-item {
      color: #999;
      font-size: 14px;
      cursor: pointer;
      &:hover,
      &.active {
        color: #333;
      }
    }
  }
  .apply-body {
    width: 100%;
    height: 850px;
    padding: 40px;
    background: #fff;
    .product-box {
      display: flex;
      column-gap: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid #e3e3e3;
      .product-img {
        width: 96px;
        height: 96px;
        border-radius: 8px;
        border: 1px solid #e3e3e3;
      }
      .product-info {
        display: flex;
        flex-direction: column;
        row-gap: 13px;
        .product-name {
          color: #333;
          font-size: 16px;
          margin-top: 12px;
        }
        .product-spec {
          color: #666;
          font-size: 14px;
        }
      }
    }
    .service-title {
      color: #333;
      font-size: 18px;
      margin-top: 30px;
    }
    .service-list {
      display: flex;
      align-items: stretch;
      margin-top: 22px;
      column-gap: 20px;
      .service-item {
        width: 410px;
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        padding: 25px 20px;
        display: flex;
        column-gap: 10px;
        cursor: pointer;
        .service-icon {
          width: 50px;
          height: 50px;
        }
        .service-text-box {
          display: flex;
          flex-direction: column;
          row-gap: 6px;
          .title-text {
            color: #333;
            font-size: 16px;
            font-weight: bold;
          }
          .title-desc {
            color: #999;
            font-size: 14px;
          }
        }
      }
    }
  }
  .apply-body-with-form {
    width: 100%;
    min-height: 850px;
    padding-bottom: 10%;
    background: #fff;
    // padding:40px;
    .top-status-box {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 32px;
      border-bottom: 1px solid #d6d6d6;
      .step-info {
        $order-red: #ff4d4f;
        $line-gray: #e5e5e5;
        $text-gray: #999;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0 10px 20px 10px;
        .step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 200px;
          .line {
            width: calc(100% - 9px);
            height: 1px;
            background: #e3e3e3;
            position: absolute;
            top: 4px;
            left: -48%;
            &.active {
              background: $order-red;
            }
          }
          .dot-info-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .dot {
              width: 9px;
              height: 9px;
              border: 1px solid #e3e3e3;
              border-radius: 50%;
              &.active {
                background: $order-red;
                border-color: $order-red;
              }
            }
            .title {
              color: #333;
              font-size: 14px;
              margin-top: 11px;
            }
          }
        }
      }
    }
    .form-detail-body {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      padding: 40px 40px 21px 40px;
      .left-form {
        display: flex;
        flex-direction: column;
        row-gap: 50px;
        .form-item {
          display: flex;
          align-items: center;
          column-gap: 10px;
          &.label-align-start {
            align-items: flex-start !important;
          }
          .item-label {
            color: #333;
            font-size: 14px;
            width: 77px;
            text-align: right;
            &.required::after {
              content: "*";
              color: red;
            }
          }
          .item-value {
            width: 600px;
            &.product-info {
              display: flex;
              align-items: center;
              column-gap: 20px;
              .product-img {
                width: 96px;
                height: 96px;
                border-radius: 8px;
                border: 1px solid #e3e3e3;
              }
              .product-info {
                display: flex;
                flex-direction: column;
                row-gap: 13px;
                .product-name {
                  color: #333;
                  font-size: 16px;
                  display: flex;
                  column-gap: 10px;
                  span {
                    cursor: pointer;
                    color: #0d99ff;
                  }
                }
                .product-spec {
                  color: #666;
                  font-size: 14px;
                }
                .product-price {
                  color: #ff5000;
                  font-size: 16px;
                }
              }
            }
            &.radio-box {
              display: flex;
            }
            &.img-list {
              display: flex;
              flex-wrap: wrap;
              gap: 12px;
              .img-item {
                width: 110px;
                height: 110px;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                }
                .video-thumb {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                .video-play-icon {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 32px;
                  height: 32px;
                  background: rgba(0, 0, 0, 0.6);
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  z-index: 2;
                  pointer-events: none;
                  svg {
                    width: 16px;
                    height: 16px;
                    fill: #fff;
                  }
                }
                &.video-item {
                  cursor: pointer;
                  &:hover {
                    opacity: 0.85;
                  }
                }
                .close-ico {
                  position: absolute;
                  top: 0;
                  right: 0;
                  width: 20px;
                  height: 20px;
                  cursor: pointer;
                  z-index: 3;
                }
              }
              .upload-btn {
                width: 110px;
                height: 110px;
                border: 1px dashed #e3e3e3;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                cursor: pointer;
                background: #f8f9fb;
                .upload-ico {
                  width: 24px;
                  height: 24px;
                }
                .upload-main-text,
                .upload-sub-text {
                  color: #999;
                  font-size: 12px;
                }
              }
            }
            &.product-select {
              width: 184px;
              height: 34px;
              border: 1px solid #e3e3e3;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              column-gap: 10px;
              color: #0d99ff;
              font-size: 16px;
              cursor: pointer;
            }
            .money-tip {
              color: #999;
              font-size: 12px;
              margin-top: 4px;
            }
          }
        }
        .submit-btn {
          width: 250px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          cursor: pointer;
          background: #ff5967;
          border-radius: 4px;
          margin-left: 90px;
        }
      }
      .right-form {
        width: 448px;
        min-height: 100%;
        border-left: 1px solid #e3e3e3;
        padding-left: 38px;
        display: flex;
        flex-direction: column;
        .detail-title {
          color: #333;
          font-size: 18px;
        }
        .detail-product-box {
          display: flex;
          column-gap: 20px;
          .detail-product-img {
            width: 96px;
            height: 96px;
            border-radius: 8px;
            border: 1px solid #e3e3e3;
          }
          .detail-product-info {
            display: flex;
            flex-direction: column;
            row-gap: 12px;
            .product-title {
              color: #333;
              font-size: 16px;
            }
            .product-spec {
              color: #666;
              font-size: 14px;
            }
          }
        }
        .detail-list-box {
          display: flex;
          flex-direction: column;
          row-gap: 8px;
          margin-top: 24px;
          .detail-list-item {
            display: flex;
            align-items: center;
            column-gap: 15px;
            .list-item-label {
              color: #666;
              font-size: 14px;
              width: 70px;
              text-align: right;
            }
            .list-item-value {
              font-size: 14px;
              color: #333;
              &.shop-name {
                cursor: pointer;
                color: #0d99ff;
                display: flex;
                align-items: center;
                column-gap: 4px;
                img {
                  width: 22px;
                  height: 22px;
                }
              }
            }
          }
        }
      }
    }
  }
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
  border-color: #ff5967;
  &::after {
    background-color: #ff5967;
  }
}
::v-deep .ivu-radio-focus {
  -webkit-box-shadow: 0 0 0 2px #ff596733;
  box-shadow: 0 0 0 2px #ff596733;
  z-index: 1;
  &::after {
    background-color: #ff5967;
  }
}
// 视频预览弹窗样式
.video-preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  .video-preview-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    .video-preview-close {
      position: fixed;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      color: #333;
      cursor: pointer;
      z-index: 1000000;
      &:hover {
        background: #fff;
      }
    }
    .video-preview {
      max-width: 90vw;
      max-height: 90vh;
      width: auto;
      height: auto;
      object-fit: contain;
      border-radius: 4px;
    }
  }
}
</style>
